import type { PracticeManagement } from "@prisma/client";

export type PmsPaymentTypeOffice = {
  isNexHealthIntegrated?: boolean | null;
  paymentTypeId?: string | null;
  enablePaymentTypeSelection?: boolean | null;
  practice?: PracticeManagement | null;
};

export function canSelectPmsPaymentType(office?: PmsPaymentTypeOffice | null) {
  if (!office?.paymentTypeId || !office.enablePaymentTypeSelection) return false;
  return Boolean(office.isNexHealthIntegrated);
}

export const canSelectNexhealthPaymentType = canSelectPmsPaymentType;

export function getDefaultPmsPaymentTypeId({
  office,
  isTerminal,
  isACH,
  isVirtual,
}: {
  office?: {
    paymentTypeId?: string | null;
    terminalPaymentId?: string | null;
    virtualPaymentTypeId?: string | null;
    achPaymentTypeId?: string | null;
  } | null;
  isTerminal?: boolean;
  isACH?: boolean;
  isVirtual?: boolean;
}) {
  if (isACH && office?.achPaymentTypeId) return office.achPaymentTypeId;
  if (isVirtual && office?.virtualPaymentTypeId) return office.virtualPaymentTypeId;
  if (isTerminal && office?.terminalPaymentId) return office.terminalPaymentId;
  return office?.paymentTypeId || "";
}

export const getDefaultNexhealthPaymentTypeId = getDefaultPmsPaymentTypeId;
